'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './event-calendar.routes';

export class EventCalendarComponent {

  constructor(ReservableEventService, $uibModal, $timeout, Auth, $state, Config, $stateParams, $location, $localStorage) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.$timeout  = $timeout;
    this.$location = $location;
    this.isAdmin = Auth.isAdminSync;
    this.ReservableEventService = ReservableEventService;
    this.$localStorage = $localStorage;

    var generalConfig = Config.getModuleConfig(Config.Modules.General);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Event Calendar " + this.type);

    this.timezone = generalConfig.getClientTimezone();

    let _calendarConfig = Config.getModuleConfig(Config.Modules.Reservation).getCalendarConfig();
    this.calendarConfig = _calendarConfig[this.type];

    this.types = Object.keys(this.calendarConfig);

    this.types.forEach(type => {
      var eventSource = {
        events: [],
        color: this.calendarConfig[type] && this.calendarConfig[type].color || '#ffcc66',
        textColor: this.calendarConfig[type] && this.calendarConfig[type].textColor || 'black'
      };

      this.eventSources.push(eventSource);
    });

    if (!$localStorage.eventCalendar)
      $localStorage.eventCalendar = {};

    if (!$localStorage.eventCalendar[this.type])
      $localStorage.eventCalendar[this.type] = {};

    if (!$localStorage.eventCalendar[this.type].display) {
      $localStorage.eventCalendar[this.type].display = {};
      this.types.forEach(type => {
        $localStorage.eventCalendar[this.type].display[type] = true;
      });
    }

    this.display = $localStorage.eventCalendar[this.type].display;

    this.doFilterData = () => {

      for (let i=0; i<this.types.length; i++) { // cleanup
        if (this.eventSources.length && this.eventSources[i].events.length) {
          this.eventSources[i].events.splice(0, this.eventSources[i].events.length);
        }
      }

      this.data.forEach(evt => {
        var event = evt;

        let idx = this.types.indexOf(event.type);

        if (this.display[event.type]) {
          this.eventSources[idx].events.push(event);
        }
        
      });

      this.$timeout(() => {
        jQuery('#fullCalendar').fullCalendar('removeEvents');
        this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
        });
      },0);
    };

    let getData = () => {

      this.ReservableEventService.getCalendarByType({type: this.type}, data => {

        this.data = data;
        this.doFilterData();

      }, err => {
        console.log('could not retrieve events from server');
      });
    };

    this.getData = getData;
    getData();

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        header: {
          left: 'title',
          center: 'month,agendaWeek,listMonth',
          right: 'today prev,next'
        },
       viewRender: (view, el) => {
         /* This is a hack, because the stick property of the event doesn't work with recurring events,
         so that these will appear multiple times per day - that's a bug.
         This hack solved the stick issue without using stick itself and thus corrupting recurring events:
         https://github.com/angular-ui/ui-calendar/issues/276 */

         jQuery('#fullCalendar').fullCalendar('removeEvents');
         this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
         })
        },
        eventRender: (event, el) => {

          // Recurring Events
          if (event.isRecurring) {
            if (! (event.start.isBefore(event.range.end) && event.start.isAfter(event.range.start)) )
              return false;
          }

          // Timezone Difference Info
          var timeZoneDiffMin = this.getTimezoneDifference(this.timezone);

          var getTimezoneDiffString = function(mins) {
            var prefix = "+";
            if (mins < 0)
              prefix = "-";

            mins = Math.abs(mins);

            var h = mins / 60 | 0,
                m = mins % 60 | 0;

            if (String(h).length == 1)
              h = "0" + String(h);

            if (String(m).length == 1)
              m = "0" + String(m);

            return prefix + String(h) + ":" + String(m);
          };

          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);

          // render the timezone offset below the event title, if
          // user is in other timezone and the event is not all day
          if (!event.allDay && timeZoneDiffMin != 0) {
            el.find('.fc-title').after(
              jQuery('<div class="tzo text-muted"/>').text( timeZoneDiffStr )
            );
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {
          this.$location.url("/event-reservation/"+calendarEvent._id)
        }
      }
    };
  }

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

}

export default angular.module('conduuApp.eventCalendar', [uiRouter])
  .config(routes)
  .component('eventCalendar', {
    template: require('./event-calendar.html'),
    controller: EventCalendarComponent,
    controllerAs: 'ctrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/event/calendar/event-calendar.component.js